import React from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddHomeOutlinedIcon from "@mui/icons-material/AddHomeOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import Logo from "../assets/images/logo.png";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import InsertChartOutlinedRoundedIcon from "@mui/icons-material/InsertChartOutlinedRounded";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { logout } from "../../login/reducers/loginThunk";
import { getbmrnlist } from "../../dataEntry/reducers/patientDataThunk";
import { useState } from "react";
import { useEffect } from "react";
import {
  useMediaQuery
} from "@mui/material";



const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  
    const location = useLocation();
    const dispatch = useDispatch();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);
  
    const [open, setOpen] = useState(false);
    const user = useSelector((state) => state.user);
    const userdata = sessionStorage.getItem("user");
    const allowedPermissions = userdata ? JSON.parse(userdata).permissions : {};
    const subScription = user.subScriptionStatus?.isSubscribed;
      const isSmall = useMediaQuery('(max-width:768px)');
      const isPortrait = useMediaQuery("(orientation: Landscape)");
      const isMobile = isSmall || isPortrait;
      console.log('111111111111',isSmall);
      console.log('222222222222',isPortrait);
      console.log('333333333333',isMobile);
  
    useEffect(() => {
      setTimeout(() => {
        const userdata = sessionStorage.getItem("user");
        setIsAdmin(userdata ? JSON.parse(userdata).is_admin : false);
        //setPermissions(userdata ? JSON.parse(userdata).is_admin : false);
      }, 1000);
    }, []);
  
    const dashboard = () => {
  
      navigate("/Dashboard");
      setIsOpen(!isOpen)
      //window.location.reload();
    }
  
    const logout = (e) => {
      e.preventDefault();
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("user");
      navigate("/login");
      window.location.reload();
    };
    const dataentryscreen = (e) => {
      dispatch(getbmrnlist());
      navigate("/AddBMRN");
     setIsOpen(!isOpen)
    };

  return (
    <div>
      {/* Show hamburger only on mobile */}
      {isMobile && (
        <>
          {/* Hamburger icon */}
          <div
            onClick={toggleMenu}
            style={{
              width: '30px',
              height: '15px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              cursor: 'pointer',
              margin: '10px',
            }}
          >
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                style={{
                  height: '2px',
                  backgroundColor: '#333',
                  borderRadius: '2px',
                }}
              />
            ))}
          </div>

          {/* Toggleable mobile menu */}
          {isOpen && (
            <div
              style={{
                position: 'absolute',
                top: '20px',
                left: 0,
                width: '80%',
                //backgroundColor: '#f8f8f8',
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                //padding: '10px 0',
              }}
            >
              <nav className="nav-position">
                      <ul className="sidebar-ul" style={{padding:"0px 2px"}}>
                       {/*  <li className="sidebar-menuitems">
                          <Link to="/" className="sidenavbar">
                            <img className="sidenavbar-logo" src={Logo} />
                          </Link>
                        </li> */}
                        <li
                          className={
                            splitLocation[1] === "Dashboard" ? "active" : "nonactive"
                          }
                        >
                          <Link to="/Dashboard" className="sidenavbar" onClick={dashboard} 
                              style={{
                                color:"#000000",
                                background:"none"
                              }}>
                            <GridViewOutlinedIcon className="nav_fill" fontSize="small" 
                                 />
                            <h6
                              className="nav_fill"
                              style={{
                                padding: "0px 0px",
                                margin: "0px 0px",
                                fontSize: "8px",
                                marginTop: "-5px",
                              }}
                            >
                              Dashboard
                            </h6>
                          </Link>
                        </li>
                        {allowedPermissions &&
                          allowedPermissions.bmrn ? (
                          <li
                            className={
                              splitLocation[1] === "dataentry" ||
                                splitLocation[1] === "NewBMRN" ||
                                splitLocation[1] === "AddBMRN" ||
                                splitLocation[1] === "DrPrescription"
                                ? "active"
                                : "nonactive"
                            }
                          //style={{marginBottom:"10px"}}
                          >
                            {!subScription ? (
                              <span className="sidenavbar">
                                <FileCopyOutlinedIcon fontSize="small" />
                                <h6
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                    opacity: "30%",
                                  }}
                                >
                                  Data Entry
                                </h6>
                              </span>
                            ) : (
                              <Link
                                to="/NewBMRN"
                                className="sidenavbar"
                                onClick={dataentryscreen}
                                style={{
                                color:"#000000",
                                background:"none"
                              }}
                              >
                                <FileCopyOutlinedIcon
                                  fontSize="small"
                                  className="nav_fill"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                  }}
                                />
                                <h6
                                  className="nav_fill"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                  }}
                                >
                                  Data Entry
                                </h6>
                              </Link>
                            )}
                          </li>
                        ) : null}
                        {allowedPermissions &&
                          allowedPermissions.hospital ? (
                          <li
                            className={splitLocation[1] === "admin" ? "active" : "nonactive"}
                          //style={{marginBottom:"10px"}}
                          >
                            {!subScription ? (
                              <span className="sidenavbar">
                                <AddHomeOutlinedIcon fontSize="small" />
                                <h6
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                    opacity: "30%",
                                  }}
                                >
                                  Hospital <br />
                                  Management
                                </h6>
                              </span>
                            ) : (
                              <Link to="/admin" className="sidenavbar" onClick={toggleMenu}
                                style={{
                                color:"#000000",
                                background:"none"
                              }} >
                                <AddHomeOutlinedIcon 
                                  className="nav_fill"
                                  fontSize="small"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                  }} />
                                <h6
                                  className="nav_fill"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                    color:"#000000"
                                  }}
                                  //color={splitLocation[1] === "admin" ? "black" : "red"}
                                
                                >
                                  Hospital <br />
                                  Management
                                </h6>
                              </Link>
                            )}
                          </li>
                        ) : null}
              
                        {allowedPermissions &&
                          allowedPermissions.user ? (
                          <li
                            className={
                              splitLocation[1] === "AdminListing" ? "active" : "nonactive"
                            }
                          //style={{marginBottom:"5px"}}
                          >
                            {!subScription ? (
                              <span className="sidenavbar">
                                <PersonAddOutlinedIcon fontSize="small" />
                                <h6
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                    opacity: "30%",
                                  }}
                                >
                                  User <br />
                                  Management
                                </h6>
                              </span>
                            ) : (
                              <Link to="/AdminListing" className="sidenavbar" onClick={toggleMenu} 
                                style={{
                                color:"#000000",
                                background:"none"
                              }}>
                                <PersonAddOutlinedIcon
                                  className="nav_fill"
                                  fontSize="small"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                  }}
                                />
                                <h6
                                  className="nav_fill"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                  }}
                                >
                                  User <br />
                                  Management
                                </h6>
                              </Link>
                            )}
                          </li>
                        ) : null}
                        {allowedPermissions &&
                          allowedPermissions.referral_doctor ? (
                          <li
                            className={
                              splitLocation[1] === "ReferralDoctor" ? "active" : "nonactive"
                            }
                          //style={{marginBottom:"5px"}}
                          >
                            {!subScription ? (
                              <span className="sidenavbar">
                                <LocalHospitalOutlinedIcon fontSize="small" />
                                <h6
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                    opacity: "30%",
                                  }}
                                >
                                  Referral <br />
                                  Management
                                </h6>
                              </span>
                            ) : (
                              <Link to="/ReferralDoctor" className="sidenavbar" onClick={toggleMenu} 
                                style={{
                                color:"#000000",
                                background:"none"
                              }}>
                                <LocalHospitalOutlinedIcon
                                  className="nav_fill"
                                  fontSize="small"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                  }}
                                />
                                <h6
                                  className="nav_fill"
                                  style={{
                                    padding: "0px 0px",
                                    margin: "0px 0px",
                                    fontSize: "8px",
                                    marginTop: "-5px",
                                  }}
                                >
                                  Referral <br />
                                  Management
                                </h6>
                              </Link>
                            )}
                          </li>
                        ) : null}
                        {allowedPermissions &&
                          allowedPermissions.reports && (
                            <li
                              className={
                                splitLocation[1] === "ReportsDashboard" ||
                                  splitLocation[1] === "Reports"
                                  ? "active"
                                  : "nonactive"
                              }
                              
                          //style={{marginBottom:"5px"}}
                            >
                              {!subScription ? (
                                <span className="sidenavbar">
                                  <InsertChartOutlinedRoundedIcon fontSize="small" />
                                  <h6
                                    style={{
                                      padding: "0px 0px",
                                      margin: "0px 0px",
                                      fontSize: "8px",
                                      marginTop: "-5px",
                                      opacity: "30%",
                                    }}
                                  >
                                    Reports
                                  </h6>
                                </span>
                              ) : (
                                <Link to="/Reports" className="sidenavbar" onClick={toggleMenu} 
                                style={{
                                color:"#000000",
                                background:"none"
                              }}>
                                  <InsertChartOutlinedRoundedIcon
                                    fontSize="small"
                                    className="nav_fill"
                                    style={{
                                      padding: "0px 0px",
                                      margin: "0px 0px",
                                    }}
                                  />
                                  <h6
                                    className="nav_fill"
                                    style={{
                                      padding: "0px 0px",
                                      margin: "0px 0px",
                                      fontSize: "8px",
                                      marginTop: "-5px",
                                    }}
                                  >
                                    Reports
                                  </h6>
                                </Link>
                              )}
                            </li>
                          )}
                        <li className={splitLocation[1] === "/" ? "active" : "nonactive"} 
                                style={{
                                color:"#000000",
                                background:"none",
                                //marginBottom:"10px"
                              }}>
                          <Link to="/" className="sidenavbar" onClick={logout} 
                                style={{
                                color:"#000000",
                                background:"none"
                              }}>
                            <LogoutOutlinedIcon
                              fontSize="small"
                              className="nav_fill"
                              style={{
                                padding: "0px 0px",
                                margin: "0px 0px",
                              }}
                            />
                            <h6
                              className="nav_fill"
                              style={{
                                padding: "0px 0px",
                                margin: "0px 0px",
                                fontSize: "8px",
                                marginTop: "-5px",
                              }}
                            >
                              Logout
                            </h6>
                          </Link>
                        </li>
                      </ul>
                    </nav>
              {/* <a href="#" style={menuItemStyle}>Home</a>
              <a href="#" style={menuItemStyle}>About</a>
              <a href="#" style={menuItemStyle}>Services</a>
              <a href="#" style={menuItemStyle}>Contact</a> */}
            </div>
          )}
        </>
      )}
    </div>
  );
};

// Reusable style
const menuItemStyle = {
  display: 'block',
  padding: '10px 20px',
  textDecoration: 'none',
  color: '#333',
  fontWeight: 'bold',
};

export default HamburgerMenu;
